import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Topbar from "../../components/TopbarChina/Topbar";
import Footer from "../../components/Footer/Footer";
import Card from "../../components/Card/Card";
import "./ChinaHotelDetails.scss";
import CityModal from "../../components/CityModal/CityModal";
import { IoChevronBack } from "react-icons/io5";
import { Link } from 'react-router-dom'

const ChinaHotelDetails = () => {
  const location = useLocation();
  const { hotel } = location.state;
  // const [showModal, setShowModal] = useState(false);
  const [info, setInfo] = useState({});

  function handleClick(params) {
    setInfo(hotel.hotels.find((el) => el.name === params));
  }

  return (
    <div className="hotel-detail-box">
      
      <Topbar bgColor={true} />
      <Link to='/hotels'><IoChevronBack  className="back"/></Link>
      {/* {showModal && <CityModal hotelInfo={info} showModal={setShowModal} />} */}

      <div className="city-cards">
        {hotel.hotels.map((el) => (
          <Link to={el.url} target="_blank" rel="noopener noreferrer" >
          <Card
            title={el.name}
            url={el.hotel_img}
            price={el.price}

          />
          </Link>
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default ChinaHotelDetails;
